import cyf from './beatmaps/cyf.js';
import gd from './beatmaps/gd.js';
const SongList = {
  cyf: cyf,
  gd: gd,
};

export default SongList;



// WEBPACK FOOTER //
// ./songs/song_list.js